import { Store } from '@tanstack/react-store'

export type UserList = {
  page: number
  size: number
  totalPages: number
  totalElements: number
  filter: UserListFilter
  sort: UserListSort
}

export const defaultUserListState: UserList = {
  page: 0,
  size: 50,
  totalPages: 0,
  totalElements: 0,
  filter: {},
  sort: {
    sortBy: {
      createDate: 'DESC',
    },
    sortOrder: ['createDate'],
  },
}

export const userListStore = new Store(defaultUserListState)

export const resetUserList = () => {
  userListStore.setState(defaultUserListState)
}

export type UserListFilter = {
  clientId?: string
  firstName?: string
  lastName?: string
  middleName?: string
  passportNumber?: string
  phone?: string
  email?: string
  platform?: string
  applicationVersion?: string
  identificationDateFrom?: string
  identificationDateTo?: string
  registrationDateFrom?: string
  registrationDateTo?: string
  identification?: string
  accountNumber?: string
  contractNumber?: string
  identityCountry?: string
  isIDXApproved?: string
  enabled?: string
  trusted?: string
  inRkl?: string
}

export type UserListSort = {
  sortBy: {
    createDate: 'DESC' | 'ASC'
  }
  sortOrder: string[]
}
